<div>
    <div class="points" *ngIf="long">
        <div class="short-remaining dark-color">You have reached <strong>Level {{ level }}</strong> by earning {{ total | number }} points in the past 12 months.</div>
        <div class="short-remaining dark-color">You have {{ remaining | number }} points available to redeem for gift cards and other rewards in our <a *ngIf="showLink" [routerLink]="['/profile', 'points-shop']"><strong>Points Shop</strong></a><span *ngIf="!showLink">Points Shop</span>.</div>
    </div>
    <div class="points" *ngIf="short">
        <span class="short-remaining dark-color">{{ remaining | number}} Reward Points</span>
    </div>

    <div class="points" *ngIf="toolbar">
        <span class="remaining">{{ remaining | number}} Reward Points</span>
    </div>
</div>